/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BusinessSignupRequestRequest,
  CheckDuplicateRequest,
  CheckDuplicateResponse,
  CustomValidationError,
  ExpressMatchingConfigResponse,
  ForManagerLocationDetail,
  ForManagerLocationResponse,
  JobsCancelSummary,
  JobsPlanPromoteRequest,
  JobsPlanSwitchPreview,
  JobsPlanSwitchRequest,
  JobsPlanUpdateRequest,
  JobsSubscriptionCharge,
  JobsSubscriptionStatus,
  LocationAddOn,
  LocationAddOnRequest,
  LocationBillingInfo,
  LocationCertificationRequirementsResponse,
  LocationCreateRequestRequest,
  LocationFavoriteGroupMember,
  LocationFavoriteGroupMemberRequest,
  LocationMatchRequestRequest,
  LocationMatchResponse,
  LocationReview,
  LocationReviewRequest,
  LocationSetupIntentResponse,
  LocationStatsOld,
  LocationsAddOnsListParams,
  LocationsAddressesListParams,
  LocationsAvailableCertificationsListParams,
  LocationsInvoicingLinkRetrieve404,
  LocationsListParams,
  LocationsPaymentMethodRetrieveParams,
  LocationsTopByPostingsListParams,
  ManagedLocationAddress,
  ManagedLocationAddressRequest,
  PaginatedCertificationList,
  PaginatedLocationAddOnList,
  PaginatedPlatformAdminLocationResponseList,
  PatchedLocationAddOnRequest,
  PatchedLocationCertificationRequirementsWriteRequest,
  PatchedManagedLocationAddressRequest,
  PatchedPlatformAdminLocationRequest,
  PlatformAdminLocationRequest,
  PlatformAdminLocationResponse,
  PlatformAdminLocationResponseRequest,
  TopLocationsAdmin
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getLocationsListUrl = (params?: LocationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/locations/?${stringifiedParams}` : `/api/locations/`
}

/**
 * A Location represents a business at a physical address.
 *
 * All gigs must be assigned to one Location. There is currently no association between locations.
 * For example, if a business owns multiple locations each location is still treated independently.
 */
export const locationsList = async (params?: LocationsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedPlatformAdminLocationResponseList> => {

  return customFetch<PaginatedPlatformAdminLocationResponseList>(getLocationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsListInfiniteQueryKey = (params?: LocationsListParams,) => {
    return [
    'infinite', `/api/locations/`, ...(params ? [params] : [])
    ] as const;
    }

export const getLocationsListQueryKey = (params?: LocationsListParams,) => {
    return [
    `/api/locations/`, ...(params ? [params] : [])
    ] as const;
    }


export const getLocationsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof locationsList>>, LocationsListParams['page']>, TError = void>(params?: LocationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData, QueryKey, LocationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsList>>, QueryKey, LocationsListParams['page']> = ({ signal, pageParam }) => locationsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData, QueryKey, LocationsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof locationsList>>>
export type LocationsListInfiniteQueryError = void


export function useLocationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsList>>, LocationsListParams['page']>, TError = void>(
 params: undefined |  LocationsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData, QueryKey, LocationsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsList>>,
          TError,
          Awaited<ReturnType<typeof locationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsList>>, LocationsListParams['page']>, TError = void>(
 params?: LocationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData, QueryKey, LocationsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsList>>,
          TError,
          Awaited<ReturnType<typeof locationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsList>>, LocationsListParams['page']>, TError = void>(
 params?: LocationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData, QueryKey, LocationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsList>>, LocationsListParams['page']>, TError = void>(
 params?: LocationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData, QueryKey, LocationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsListQueryOptions = <TData = Awaited<ReturnType<typeof locationsList>>, TError = void>(params?: LocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsList>>> = ({ signal }) => locationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsListQueryResult = NonNullable<Awaited<ReturnType<typeof locationsList>>>
export type LocationsListQueryError = void


export function useLocationsList<TData = Awaited<ReturnType<typeof locationsList>>, TError = void>(
 params: undefined |  LocationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsList>>,
          TError,
          Awaited<ReturnType<typeof locationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsList<TData = Awaited<ReturnType<typeof locationsList>>, TError = void>(
 params?: LocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsList>>,
          TError,
          Awaited<ReturnType<typeof locationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsList<TData = Awaited<ReturnType<typeof locationsList>>, TError = void>(
 params?: LocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsList<TData = Awaited<ReturnType<typeof locationsList>>, TError = void>(
 params?: LocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsCreateUrl = () => {




  return `/api/locations/`
}

/**
 * A Location represents a business at a physical address.
 *
 * All gigs must be assigned to one Location. There is currently no association between locations.
 * For example, if a business owns multiple locations each location is still treated independently.
 */
export const locationsCreate = async (locationCreateRequestRequest?: LocationCreateRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<ForManagerLocationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ForManagerLocationResponse>(getLocationsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(locationCreateRequestRequest)
  }
);}





export const getLocationsCreateMutationKey = () => ['locationsCreate'] as const;

export const getLocationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsCreate>>, TError,LocationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsCreate>>, TError,LocationsCreateMutationVariables, TContext> => {

const mutationKey = getLocationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsCreate>>, LocationsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  locationsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsCreate>>>
    export type LocationsCreateMutationBody = LocationCreateRequestRequest | undefined
    export type LocationsCreateMutationError = void
    export type LocationsCreateMutationVariables = {data?: LocationCreateRequestRequest}

    export const useLocationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsCreate>>, TError,LocationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsCreate>>,
        TError,
        LocationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsCreateMutationOptions(options), queryClient);
    }
    export const getLocationsAddOnsListUrl = (locationId: number,
    params?: LocationsAddOnsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/locations/${locationId}/add-ons/?${stringifiedParams}` : `/api/locations/${locationId}/add-ons/`
}

/**
 * Add-on configurations for a location.
 *
 * Examples: supplemental billing, tipping options. Managers can create,
 * update, and list add-ons that apply to gigs posted at their location.
 */
export const locationsAddOnsList = async (locationId: number,
    params?: LocationsAddOnsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedLocationAddOnList> => {

  return customFetch<PaginatedLocationAddOnList>(getLocationsAddOnsListUrl(locationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsAddOnsListInfiniteQueryKey = (locationId: number,
    params?: LocationsAddOnsListParams,) => {
    return [
    'infinite', `/api/locations/${locationId}/add-ons/`, ...(params ? [params] : [])
    ] as const;
    }

export const getLocationsAddOnsListQueryKey = (locationId: number,
    params?: LocationsAddOnsListParams,) => {
    return [
    `/api/locations/${locationId}/add-ons/`, ...(params ? [params] : [])
    ] as const;
    }


export const getLocationsAddOnsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof locationsAddOnsList>>, LocationsAddOnsListParams['page']>, TError = void>(locationId: number,
    params?: LocationsAddOnsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData, QueryKey, LocationsAddOnsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsAddOnsListInfiniteQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsAddOnsList>>, QueryKey, LocationsAddOnsListParams['page']> = ({ signal, pageParam }) => locationsAddOnsList(locationId,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData, QueryKey, LocationsAddOnsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsAddOnsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof locationsAddOnsList>>>
export type LocationsAddOnsListInfiniteQueryError = void


export function useLocationsAddOnsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsAddOnsList>>, LocationsAddOnsListParams['page']>, TError = void>(
 locationId: number,
    params: undefined |  LocationsAddOnsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData, QueryKey, LocationsAddOnsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAddOnsList>>,
          TError,
          Awaited<ReturnType<typeof locationsAddOnsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAddOnsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsAddOnsList>>, LocationsAddOnsListParams['page']>, TError = void>(
 locationId: number,
    params?: LocationsAddOnsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData, QueryKey, LocationsAddOnsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAddOnsList>>,
          TError,
          Awaited<ReturnType<typeof locationsAddOnsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAddOnsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsAddOnsList>>, LocationsAddOnsListParams['page']>, TError = void>(
 locationId: number,
    params?: LocationsAddOnsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData, QueryKey, LocationsAddOnsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsAddOnsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsAddOnsList>>, LocationsAddOnsListParams['page']>, TError = void>(
 locationId: number,
    params?: LocationsAddOnsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData, QueryKey, LocationsAddOnsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsAddOnsListInfiniteQueryOptions(locationId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsAddOnsListQueryOptions = <TData = Awaited<ReturnType<typeof locationsAddOnsList>>, TError = void>(locationId: number,
    params?: LocationsAddOnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsAddOnsListQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsAddOnsList>>> = ({ signal }) => locationsAddOnsList(locationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsAddOnsListQueryResult = NonNullable<Awaited<ReturnType<typeof locationsAddOnsList>>>
export type LocationsAddOnsListQueryError = void


export function useLocationsAddOnsList<TData = Awaited<ReturnType<typeof locationsAddOnsList>>, TError = void>(
 locationId: number,
    params: undefined |  LocationsAddOnsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAddOnsList>>,
          TError,
          Awaited<ReturnType<typeof locationsAddOnsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAddOnsList<TData = Awaited<ReturnType<typeof locationsAddOnsList>>, TError = void>(
 locationId: number,
    params?: LocationsAddOnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAddOnsList>>,
          TError,
          Awaited<ReturnType<typeof locationsAddOnsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAddOnsList<TData = Awaited<ReturnType<typeof locationsAddOnsList>>, TError = void>(
 locationId: number,
    params?: LocationsAddOnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsAddOnsList<TData = Awaited<ReturnType<typeof locationsAddOnsList>>, TError = void>(
 locationId: number,
    params?: LocationsAddOnsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsAddOnsListQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsAddOnsCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/add-ons/`
}

/**
 * Add-on configurations for a location.
 *
 * Examples: supplemental billing, tipping options. Managers can create,
 * update, and list add-ons that apply to gigs posted at their location.
 */
export const locationsAddOnsCreate = async (locationId: number,
    locationAddOnRequest: LocationAddOnRequest, options?: Parameters<typeof customFetch>[1]): Promise<LocationAddOn> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<LocationAddOn>(getLocationsAddOnsCreateUrl(locationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(locationAddOnRequest)
  }
);}





export const getLocationsAddOnsCreateMutationKey = () => ['locationsAddOnsCreate'] as const;

export const getLocationsAddOnsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddOnsCreate>>, TError,LocationsAddOnsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsAddOnsCreate>>, TError,LocationsAddOnsCreateMutationVariables, TContext> => {

const mutationKey = getLocationsAddOnsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsAddOnsCreate>>, LocationsAddOnsCreateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  locationsAddOnsCreate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsAddOnsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsAddOnsCreate>>>
    export type LocationsAddOnsCreateMutationBody = LocationAddOnRequest
    export type LocationsAddOnsCreateMutationError = void
    export type LocationsAddOnsCreateMutationVariables = {locationId: number;data: LocationAddOnRequest}

    export const useLocationsAddOnsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddOnsCreate>>, TError,LocationsAddOnsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsAddOnsCreate>>,
        TError,
        LocationsAddOnsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsAddOnsCreateMutationOptions(options), queryClient);
    }
    export const getLocationsAddOnsRetrieveUrl = (locationId: number,
    id: number,) => {




  return `/api/locations/${locationId}/add-ons/${id}/`
}

/**
 * Add-on configurations for a location.
 *
 * Examples: supplemental billing, tipping options. Managers can create,
 * update, and list add-ons that apply to gigs posted at their location.
 */
export const locationsAddOnsRetrieve = async (locationId: number,
    id: number, options?: Parameters<typeof customFetch>[1]): Promise<LocationAddOn> => {

  return customFetch<LocationAddOn>(getLocationsAddOnsRetrieveUrl(locationId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsAddOnsRetrieveQueryKey = (locationId: number,
    id: number,) => {
    return [
    `/api/locations/${locationId}/add-ons/${id}/`
    ] as const;
    }


export const getLocationsAddOnsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError = void>(locationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsAddOnsRetrieveQueryKey(locationId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsAddOnsRetrieve>>> = ({ signal }) => locationsAddOnsRetrieve(locationId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsAddOnsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsAddOnsRetrieve>>>
export type LocationsAddOnsRetrieveQueryError = void


export function useLocationsAddOnsRetrieve<TData = Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError = void>(
 locationId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAddOnsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsAddOnsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAddOnsRetrieve<TData = Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError = void>(
 locationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAddOnsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsAddOnsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAddOnsRetrieve<TData = Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError = void>(
 locationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsAddOnsRetrieve<TData = Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError = void>(
 locationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddOnsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsAddOnsRetrieveQueryOptions(locationId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsAddOnsUpdateUrl = (locationId: number,
    id: number,) => {




  return `/api/locations/${locationId}/add-ons/${id}/`
}

/**
 * Add-on configurations for a location.
 *
 * Examples: supplemental billing, tipping options. Managers can create,
 * update, and list add-ons that apply to gigs posted at their location.
 */
export const locationsAddOnsUpdate = async (locationId: number,
    id: number,
    locationAddOnRequest: LocationAddOnRequest, options?: Parameters<typeof customFetch>[1]): Promise<LocationAddOn> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<LocationAddOn>(getLocationsAddOnsUpdateUrl(locationId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(locationAddOnRequest)
  }
);}





export const getLocationsAddOnsUpdateMutationKey = () => ['locationsAddOnsUpdate'] as const;

export const getLocationsAddOnsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddOnsUpdate>>, TError,LocationsAddOnsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsAddOnsUpdate>>, TError,LocationsAddOnsUpdateMutationVariables, TContext> => {

const mutationKey = getLocationsAddOnsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsAddOnsUpdate>>, LocationsAddOnsUpdateMutationVariables> = (props) => {
          const {locationId,id,data} = props ?? {};

          return  locationsAddOnsUpdate(locationId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsAddOnsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsAddOnsUpdate>>>
    export type LocationsAddOnsUpdateMutationBody = LocationAddOnRequest
    export type LocationsAddOnsUpdateMutationError = void
    export type LocationsAddOnsUpdateMutationVariables = {locationId: number;id: number;data: LocationAddOnRequest}

    export const useLocationsAddOnsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddOnsUpdate>>, TError,LocationsAddOnsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsAddOnsUpdate>>,
        TError,
        LocationsAddOnsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsAddOnsUpdateMutationOptions(options), queryClient);
    }
    export const getLocationsAddOnsPartialUpdateUrl = (locationId: number,
    id: number,) => {




  return `/api/locations/${locationId}/add-ons/${id}/`
}

/**
 * Add-on configurations for a location.
 *
 * Examples: supplemental billing, tipping options. Managers can create,
 * update, and list add-ons that apply to gigs posted at their location.
 */
export const locationsAddOnsPartialUpdate = async (locationId: number,
    id: number,
    patchedLocationAddOnRequest?: PatchedLocationAddOnRequest, options?: Parameters<typeof customFetch>[1]): Promise<LocationAddOn> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<LocationAddOn>(getLocationsAddOnsPartialUpdateUrl(locationId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedLocationAddOnRequest)
  }
);}





export const getLocationsAddOnsPartialUpdateMutationKey = () => ['locationsAddOnsPartialUpdate'] as const;

export const getLocationsAddOnsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddOnsPartialUpdate>>, TError,LocationsAddOnsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsAddOnsPartialUpdate>>, TError,LocationsAddOnsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getLocationsAddOnsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsAddOnsPartialUpdate>>, LocationsAddOnsPartialUpdateMutationVariables> = (props) => {
          const {locationId,id,data} = props ?? {};

          return  locationsAddOnsPartialUpdate(locationId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsAddOnsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsAddOnsPartialUpdate>>>
    export type LocationsAddOnsPartialUpdateMutationBody = PatchedLocationAddOnRequest | undefined
    export type LocationsAddOnsPartialUpdateMutationError = void
    export type LocationsAddOnsPartialUpdateMutationVariables = {locationId: number;id: number;data?: PatchedLocationAddOnRequest}

    export const useLocationsAddOnsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddOnsPartialUpdate>>, TError,LocationsAddOnsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsAddOnsPartialUpdate>>,
        TError,
        LocationsAddOnsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsAddOnsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getLocationsAddressesListUrl = (locationId: number,
    params?: LocationsAddressesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/locations/${locationId}/addresses/?${stringifiedParams}` : `/api/locations/${locationId}/addresses/`
}

export const locationsAddressesList = async (locationId: number,
    params?: LocationsAddressesListParams, options?: Parameters<typeof customFetch>[1]): Promise<ManagedLocationAddress[]> => {

  return customFetch<ManagedLocationAddress[]>(getLocationsAddressesListUrl(locationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsAddressesListQueryKey = (locationId: number,
    params?: LocationsAddressesListParams,) => {
    return [
    `/api/locations/${locationId}/addresses/`, ...(params ? [params] : [])
    ] as const;
    }


export const getLocationsAddressesListQueryOptions = <TData = Awaited<ReturnType<typeof locationsAddressesList>>, TError = void>(locationId: number,
    params?: LocationsAddressesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsAddressesListQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsAddressesList>>> = ({ signal }) => locationsAddressesList(locationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsAddressesListQueryResult = NonNullable<Awaited<ReturnType<typeof locationsAddressesList>>>
export type LocationsAddressesListQueryError = void


export function useLocationsAddressesList<TData = Awaited<ReturnType<typeof locationsAddressesList>>, TError = void>(
 locationId: number,
    params: undefined |  LocationsAddressesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAddressesList>>,
          TError,
          Awaited<ReturnType<typeof locationsAddressesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAddressesList<TData = Awaited<ReturnType<typeof locationsAddressesList>>, TError = void>(
 locationId: number,
    params?: LocationsAddressesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAddressesList>>,
          TError,
          Awaited<ReturnType<typeof locationsAddressesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAddressesList<TData = Awaited<ReturnType<typeof locationsAddressesList>>, TError = void>(
 locationId: number,
    params?: LocationsAddressesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsAddressesList<TData = Awaited<ReturnType<typeof locationsAddressesList>>, TError = void>(
 locationId: number,
    params?: LocationsAddressesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsAddressesListQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsAddressesCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/addresses/`
}

export const locationsAddressesCreate = async (locationId: number,
    managedLocationAddressRequest: ManagedLocationAddressRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManagedLocationAddress> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagedLocationAddress>(getLocationsAddressesCreateUrl(locationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(managedLocationAddressRequest)
  }
);}





export const getLocationsAddressesCreateMutationKey = () => ['locationsAddressesCreate'] as const;

export const getLocationsAddressesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesCreate>>, TError,LocationsAddressesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesCreate>>, TError,LocationsAddressesCreateMutationVariables, TContext> => {

const mutationKey = getLocationsAddressesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsAddressesCreate>>, LocationsAddressesCreateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  locationsAddressesCreate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsAddressesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsAddressesCreate>>>
    export type LocationsAddressesCreateMutationBody = ManagedLocationAddressRequest
    export type LocationsAddressesCreateMutationError = void
    export type LocationsAddressesCreateMutationVariables = {locationId: number;data: ManagedLocationAddressRequest}

    export const useLocationsAddressesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesCreate>>, TError,LocationsAddressesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsAddressesCreate>>,
        TError,
        LocationsAddressesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsAddressesCreateMutationOptions(options), queryClient);
    }
    export const getLocationsAddressesRetrieveUrl = (locationId: number,
    id: number,) => {




  return `/api/locations/${locationId}/addresses/${id}/`
}

export const locationsAddressesRetrieve = async (locationId: number,
    id: number, options?: Parameters<typeof customFetch>[1]): Promise<ManagedLocationAddress> => {

  return customFetch<ManagedLocationAddress>(getLocationsAddressesRetrieveUrl(locationId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsAddressesRetrieveQueryKey = (locationId: number,
    id: number,) => {
    return [
    `/api/locations/${locationId}/addresses/${id}/`
    ] as const;
    }


export const getLocationsAddressesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError = void>(locationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsAddressesRetrieveQueryKey(locationId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsAddressesRetrieve>>> = ({ signal }) => locationsAddressesRetrieve(locationId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsAddressesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsAddressesRetrieve>>>
export type LocationsAddressesRetrieveQueryError = void


export function useLocationsAddressesRetrieve<TData = Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError = void>(
 locationId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAddressesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsAddressesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAddressesRetrieve<TData = Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError = void>(
 locationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAddressesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsAddressesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAddressesRetrieve<TData = Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError = void>(
 locationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsAddressesRetrieve<TData = Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError = void>(
 locationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAddressesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsAddressesRetrieveQueryOptions(locationId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsAddressesUpdateUrl = (locationId: number,
    id: number,) => {




  return `/api/locations/${locationId}/addresses/${id}/`
}

export const locationsAddressesUpdate = async (locationId: number,
    id: number,
    managedLocationAddressRequest: ManagedLocationAddressRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManagedLocationAddress> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagedLocationAddress>(getLocationsAddressesUpdateUrl(locationId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(managedLocationAddressRequest)
  }
);}





export const getLocationsAddressesUpdateMutationKey = () => ['locationsAddressesUpdate'] as const;

export const getLocationsAddressesUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesUpdate>>, TError,LocationsAddressesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesUpdate>>, TError,LocationsAddressesUpdateMutationVariables, TContext> => {

const mutationKey = getLocationsAddressesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsAddressesUpdate>>, LocationsAddressesUpdateMutationVariables> = (props) => {
          const {locationId,id,data} = props ?? {};

          return  locationsAddressesUpdate(locationId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsAddressesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsAddressesUpdate>>>
    export type LocationsAddressesUpdateMutationBody = ManagedLocationAddressRequest
    export type LocationsAddressesUpdateMutationError = void
    export type LocationsAddressesUpdateMutationVariables = {locationId: number;id: number;data: ManagedLocationAddressRequest}

    export const useLocationsAddressesUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesUpdate>>, TError,LocationsAddressesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsAddressesUpdate>>,
        TError,
        LocationsAddressesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsAddressesUpdateMutationOptions(options), queryClient);
    }
    export const getLocationsAddressesPartialUpdateUrl = (locationId: number,
    id: number,) => {




  return `/api/locations/${locationId}/addresses/${id}/`
}

export const locationsAddressesPartialUpdate = async (locationId: number,
    id: number,
    patchedManagedLocationAddressRequest?: PatchedManagedLocationAddressRequest, options?: Parameters<typeof customFetch>[1]): Promise<ManagedLocationAddress> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ManagedLocationAddress>(getLocationsAddressesPartialUpdateUrl(locationId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedManagedLocationAddressRequest)
  }
);}





export const getLocationsAddressesPartialUpdateMutationKey = () => ['locationsAddressesPartialUpdate'] as const;

export const getLocationsAddressesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesPartialUpdate>>, TError,LocationsAddressesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesPartialUpdate>>, TError,LocationsAddressesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getLocationsAddressesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsAddressesPartialUpdate>>, LocationsAddressesPartialUpdateMutationVariables> = (props) => {
          const {locationId,id,data} = props ?? {};

          return  locationsAddressesPartialUpdate(locationId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsAddressesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsAddressesPartialUpdate>>>
    export type LocationsAddressesPartialUpdateMutationBody = PatchedManagedLocationAddressRequest | undefined
    export type LocationsAddressesPartialUpdateMutationError = void
    export type LocationsAddressesPartialUpdateMutationVariables = {locationId: number;id: number;data?: PatchedManagedLocationAddressRequest}

    export const useLocationsAddressesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesPartialUpdate>>, TError,LocationsAddressesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsAddressesPartialUpdate>>,
        TError,
        LocationsAddressesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsAddressesPartialUpdateMutationOptions(options), queryClient);
    }
    export const getLocationsAddressesDestroyUrl = (locationId: number,
    id: number,) => {




  return `/api/locations/${locationId}/addresses/${id}/`
}

export const locationsAddressesDestroy = async (locationId: number,
    id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getLocationsAddressesDestroyUrl(locationId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLocationsAddressesDestroyMutationKey = () => ['locationsAddressesDestroy'] as const;

export const getLocationsAddressesDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesDestroy>>, TError,LocationsAddressesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesDestroy>>, TError,LocationsAddressesDestroyMutationVariables, TContext> => {

const mutationKey = getLocationsAddressesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsAddressesDestroy>>, LocationsAddressesDestroyMutationVariables> = (props) => {
          const {locationId,id} = props ?? {};

          return  locationsAddressesDestroy(locationId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsAddressesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof locationsAddressesDestroy>>>

    export type LocationsAddressesDestroyMutationError = void
    export type LocationsAddressesDestroyMutationVariables = {locationId: number;id: number}

    export const useLocationsAddressesDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsAddressesDestroy>>, TError,LocationsAddressesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsAddressesDestroy>>,
        TError,
        LocationsAddressesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsAddressesDestroyMutationOptions(options), queryClient);
    }
    export const getLocationsAvailableCertificationsListUrl = (locationId: number,
    params?: LocationsAvailableCertificationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/locations/${locationId}/available-certifications/?${stringifiedParams}` : `/api/locations/${locationId}/available-certifications/`
}

/**
 * Active certifications that can legally be required by THIS location.
 *
 * Mounted at ``/api/locations/{location_id}/available-certifications/``.
 * Wired via ``api/certifications/urls/location_requirement_urls.py``, which
 * is included from ``api/urls.py``'s ``locations_patterns`` so the URL is
 * nested under ``locations/`` without coupling the locations app to the
 * certifications app (see ``.claude/rules/codebase-patterns.md``,
 * "Cross-domain URL nesting").
 *
 * The endpoint is the canonical picker for the location cert-requirements
 * admin UX. Filter shape mirrors the write-side invariant enforced in
 * ``LocationCertificationRequirementService.set_requirements()`` (CORE-5771)
 * so GET (what the picker shows) and PATCH (what save accepts) can never
 * disagree:
 *
 *   - universal certs (no ``CertificationMarketLink`` rows) always pass
 *     through;
 *   - market-aware certs whose ``market_links`` include the location's
 *     market are included;
 *   - market-aware certs whose ``market_links`` cover a different market
 *     are excluded.
 *
 * Inactive certs are never returned — the
 * underlying queryset uses ``Certification.objects`` (active-only manager).
 * Response shape is identical to ``CertificationSerializer`` so the frontend
 * can swap the URL with no payload contract change.
 *
 * Permissions mirror ``LocationCertificationRequirementViewSet``: anyone
 * who can manage the location (gigpro_admin, location-manager, or org
 * admin) reads this list. The URL path identifies the location, so we don't
 * need a query-param flag — the endpoint's purpose is unambiguous from its
 * URL alone, which closes the "frontend forgot to pass ?for_location_id"
 * failure mode that the earlier query-param design (CORE-5772 v1) was
 * vulnerable to.
 */
export const locationsAvailableCertificationsList = async (locationId: number,
    params?: LocationsAvailableCertificationsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedCertificationList> => {

  return customFetch<PaginatedCertificationList>(getLocationsAvailableCertificationsListUrl(locationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsAvailableCertificationsListInfiniteQueryKey = (locationId: number,
    params?: LocationsAvailableCertificationsListParams,) => {
    return [
    'infinite', `/api/locations/${locationId}/available-certifications/`, ...(params ? [params] : [])
    ] as const;
    }

export const getLocationsAvailableCertificationsListQueryKey = (locationId: number,
    params?: LocationsAvailableCertificationsListParams,) => {
    return [
    `/api/locations/${locationId}/available-certifications/`, ...(params ? [params] : [])
    ] as const;
    }


export const getLocationsAvailableCertificationsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, LocationsAvailableCertificationsListParams['page']>, TError = void>(locationId: number,
    params?: LocationsAvailableCertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData, QueryKey, LocationsAvailableCertificationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsAvailableCertificationsListInfiniteQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, QueryKey, LocationsAvailableCertificationsListParams['page']> = ({ signal, pageParam }) => locationsAvailableCertificationsList(locationId,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData, QueryKey, LocationsAvailableCertificationsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsAvailableCertificationsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>>
export type LocationsAvailableCertificationsListInfiniteQueryError = void


export function useLocationsAvailableCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, LocationsAvailableCertificationsListParams['page']>, TError = void>(
 locationId: number,
    params: undefined |  LocationsAvailableCertificationsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData, QueryKey, LocationsAvailableCertificationsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAvailableCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAvailableCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, LocationsAvailableCertificationsListParams['page']>, TError = void>(
 locationId: number,
    params?: LocationsAvailableCertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData, QueryKey, LocationsAvailableCertificationsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAvailableCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAvailableCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, LocationsAvailableCertificationsListParams['page']>, TError = void>(
 locationId: number,
    params?: LocationsAvailableCertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData, QueryKey, LocationsAvailableCertificationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsAvailableCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, LocationsAvailableCertificationsListParams['page']>, TError = void>(
 locationId: number,
    params?: LocationsAvailableCertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData, QueryKey, LocationsAvailableCertificationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsAvailableCertificationsListInfiniteQueryOptions(locationId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsAvailableCertificationsListQueryOptions = <TData = Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError = void>(locationId: number,
    params?: LocationsAvailableCertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsAvailableCertificationsListQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>> = ({ signal }) => locationsAvailableCertificationsList(locationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsAvailableCertificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>>
export type LocationsAvailableCertificationsListQueryError = void


export function useLocationsAvailableCertificationsList<TData = Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError = void>(
 locationId: number,
    params: undefined |  LocationsAvailableCertificationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAvailableCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof locationsAvailableCertificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAvailableCertificationsList<TData = Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError = void>(
 locationId: number,
    params?: LocationsAvailableCertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsAvailableCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof locationsAvailableCertificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsAvailableCertificationsList<TData = Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError = void>(
 locationId: number,
    params?: LocationsAvailableCertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsAvailableCertificationsList<TData = Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError = void>(
 locationId: number,
    params?: LocationsAvailableCertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsAvailableCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsAvailableCertificationsListQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsCertificationRequirementsRetrieveUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/certification-requirements/`
}

/**
 * GET on the collection root — returns the full list wrapped in
 * ``{results: [...]}``.
 */
export const locationsCertificationRequirementsRetrieve = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<LocationCertificationRequirementsResponse> => {

  return customFetch<LocationCertificationRequirementsResponse>(getLocationsCertificationRequirementsRetrieveUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsCertificationRequirementsRetrieveQueryKey = (locationId: number,) => {
    return [
    `/api/locations/${locationId}/certification-requirements/`
    ] as const;
    }


export const getLocationsCertificationRequirementsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError = void>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsCertificationRequirementsRetrieveQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>> = ({ signal }) => locationsCertificationRequirementsRetrieve(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsCertificationRequirementsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>>
export type LocationsCertificationRequirementsRetrieveQueryError = void


export function useLocationsCertificationRequirementsRetrieve<TData = Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError = void>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsCertificationRequirementsRetrieve<TData = Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsCertificationRequirementsRetrieve<TData = Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsCertificationRequirementsRetrieve<TData = Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsCertificationRequirementsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsCertificationRequirementsRetrieveQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsCertificationRequirementsPartialUpdateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/certification-requirements/`
}

/**
 * PATCH on the collection root — full-replace reconciliation.
 */
export const locationsCertificationRequirementsPartialUpdate = async (locationId: number,
    patchedLocationCertificationRequirementsWriteRequest?: PatchedLocationCertificationRequirementsWriteRequest, options?: Parameters<typeof customFetch>[1]): Promise<LocationCertificationRequirementsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<LocationCertificationRequirementsResponse>(getLocationsCertificationRequirementsPartialUpdateUrl(locationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedLocationCertificationRequirementsWriteRequest)
  }
);}





export const getLocationsCertificationRequirementsPartialUpdateMutationKey = () => ['locationsCertificationRequirementsPartialUpdate'] as const;

export const getLocationsCertificationRequirementsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsCertificationRequirementsPartialUpdate>>, TError,LocationsCertificationRequirementsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsCertificationRequirementsPartialUpdate>>, TError,LocationsCertificationRequirementsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getLocationsCertificationRequirementsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsCertificationRequirementsPartialUpdate>>, LocationsCertificationRequirementsPartialUpdateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  locationsCertificationRequirementsPartialUpdate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsCertificationRequirementsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsCertificationRequirementsPartialUpdate>>>
    export type LocationsCertificationRequirementsPartialUpdateMutationBody = PatchedLocationCertificationRequirementsWriteRequest | undefined
    export type LocationsCertificationRequirementsPartialUpdateMutationError = void
    export type LocationsCertificationRequirementsPartialUpdateMutationVariables = {locationId: number;data?: PatchedLocationCertificationRequirementsWriteRequest}

    export const useLocationsCertificationRequirementsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsCertificationRequirementsPartialUpdate>>, TError,LocationsCertificationRequirementsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsCertificationRequirementsPartialUpdate>>,
        TError,
        LocationsCertificationRequirementsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsCertificationRequirementsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getLocationsFavoriteGroupMembersCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/favorite-group-members/`
}

/**
 * Add or remove a pro in a location's auto-generated FAVORITES group for one skill.
 *
 * Mounted at ``/api/locations/{location_id}/favorite-group-members/`` via ``locations_patterns``
 * (see ``.claude/rules/codebase-patterns.md``, "Cross-domain URL nesting"). A merged favorites card
 * spans several locations, so an edit on it targets the page location's own (location, skill) group,
 * which is created on first add. Access is limited to active managers of the location in the URL.
 */
export const locationsFavoriteGroupMembersCreate = async (locationId: number,
    locationFavoriteGroupMemberRequest: LocationFavoriteGroupMemberRequest, options?: Parameters<typeof customFetch>[1]): Promise<LocationFavoriteGroupMember> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<LocationFavoriteGroupMember>(getLocationsFavoriteGroupMembersCreateUrl(locationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(locationFavoriteGroupMemberRequest)
  }
);}





export const getLocationsFavoriteGroupMembersCreateMutationKey = () => ['locationsFavoriteGroupMembersCreate'] as const;

export const getLocationsFavoriteGroupMembersCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsFavoriteGroupMembersCreate>>, TError,LocationsFavoriteGroupMembersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsFavoriteGroupMembersCreate>>, TError,LocationsFavoriteGroupMembersCreateMutationVariables, TContext> => {

const mutationKey = getLocationsFavoriteGroupMembersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsFavoriteGroupMembersCreate>>, LocationsFavoriteGroupMembersCreateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  locationsFavoriteGroupMembersCreate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsFavoriteGroupMembersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsFavoriteGroupMembersCreate>>>
    export type LocationsFavoriteGroupMembersCreateMutationBody = LocationFavoriteGroupMemberRequest
    export type LocationsFavoriteGroupMembersCreateMutationError = void
    export type LocationsFavoriteGroupMembersCreateMutationVariables = {locationId: number;data: LocationFavoriteGroupMemberRequest}

    export const useLocationsFavoriteGroupMembersCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsFavoriteGroupMembersCreate>>, TError,LocationsFavoriteGroupMembersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsFavoriteGroupMembersCreate>>,
        TError,
        LocationsFavoriteGroupMembersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsFavoriteGroupMembersCreateMutationOptions(options), queryClient);
    }
    export const getLocationsFavoriteGroupMembersDestroyUrl = (locationId: number,
    skillId: number,
    proId: number,) => {




  return `/api/locations/${locationId}/favorite-group-members/${skillId}/${proId}/`
}

/**
 * Add or remove a pro in a location's auto-generated FAVORITES group for one skill.
 *
 * Mounted at ``/api/locations/{location_id}/favorite-group-members/`` via ``locations_patterns``
 * (see ``.claude/rules/codebase-patterns.md``, "Cross-domain URL nesting"). A merged favorites card
 * spans several locations, so an edit on it targets the page location's own (location, skill) group,
 * which is created on first add. Access is limited to active managers of the location in the URL.
 */
export const locationsFavoriteGroupMembersDestroy = async (locationId: number,
    skillId: number,
    proId: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getLocationsFavoriteGroupMembersDestroyUrl(locationId,skillId,proId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLocationsFavoriteGroupMembersDestroyMutationKey = () => ['locationsFavoriteGroupMembersDestroy'] as const;

export const getLocationsFavoriteGroupMembersDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsFavoriteGroupMembersDestroy>>, TError,LocationsFavoriteGroupMembersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsFavoriteGroupMembersDestroy>>, TError,LocationsFavoriteGroupMembersDestroyMutationVariables, TContext> => {

const mutationKey = getLocationsFavoriteGroupMembersDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsFavoriteGroupMembersDestroy>>, LocationsFavoriteGroupMembersDestroyMutationVariables> = (props) => {
          const {locationId,skillId,proId} = props ?? {};

          return  locationsFavoriteGroupMembersDestroy(locationId,skillId,proId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsFavoriteGroupMembersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof locationsFavoriteGroupMembersDestroy>>>

    export type LocationsFavoriteGroupMembersDestroyMutationError = void
    export type LocationsFavoriteGroupMembersDestroyMutationVariables = {locationId: number;skillId: number;proId: number}

    export const useLocationsFavoriteGroupMembersDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsFavoriteGroupMembersDestroy>>, TError,LocationsFavoriteGroupMembersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsFavoriteGroupMembersDestroy>>,
        TError,
        LocationsFavoriteGroupMembersDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsFavoriteGroupMembersDestroyMutationOptions(options), queryClient);
    }
    export const getLocationsJobsPlanUpdateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-plan/`
}

/**
 * Staff-only switch between the pay-per-hire and subscription Jobs plans for one location.
 */
export const locationsJobsPlanUpdate = async (locationId: number,
    jobsPlanUpdateRequest: JobsPlanUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobsSubscriptionStatus> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobsSubscriptionStatus>(getLocationsJobsPlanUpdateUrl(locationId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobsPlanUpdateRequest)
  }
);}





export const getLocationsJobsPlanUpdateMutationKey = () => ['locationsJobsPlanUpdate'] as const;

export const getLocationsJobsPlanUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanUpdate>>, TError,LocationsJobsPlanUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanUpdate>>, TError,LocationsJobsPlanUpdateMutationVariables, TContext> => {

const mutationKey = getLocationsJobsPlanUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsJobsPlanUpdate>>, LocationsJobsPlanUpdateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  locationsJobsPlanUpdate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsJobsPlanUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsJobsPlanUpdate>>>
    export type LocationsJobsPlanUpdateMutationBody = JobsPlanUpdateRequest
    export type LocationsJobsPlanUpdateMutationError = void
    export type LocationsJobsPlanUpdateMutationVariables = {locationId: number;data: JobsPlanUpdateRequest}

    export const useLocationsJobsPlanUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanUpdate>>, TError,LocationsJobsPlanUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsJobsPlanUpdate>>,
        TError,
        LocationsJobsPlanUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsJobsPlanUpdateMutationOptions(options), queryClient);
    }
    export const getLocationsJobsPlanMoveToJobsPlanCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-plan/move-to-jobs-plan/`
}

/**
 * Staff only: put the location on the Jobs plan, optionally starting its free trial now.
 */
export const locationsJobsPlanMoveToJobsPlanCreate = async (locationId: number,
    jobsPlanPromoteRequest: JobsPlanPromoteRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobsSubscriptionStatus> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobsSubscriptionStatus>(getLocationsJobsPlanMoveToJobsPlanCreateUrl(locationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobsPlanPromoteRequest)
  }
);}





export const getLocationsJobsPlanMoveToJobsPlanCreateMutationKey = () => ['locationsJobsPlanMoveToJobsPlanCreate'] as const;

export const getLocationsJobsPlanMoveToJobsPlanCreateMutationOptions = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanMoveToJobsPlanCreate>>, TError,LocationsJobsPlanMoveToJobsPlanCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanMoveToJobsPlanCreate>>, TError,LocationsJobsPlanMoveToJobsPlanCreateMutationVariables, TContext> => {

const mutationKey = getLocationsJobsPlanMoveToJobsPlanCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsJobsPlanMoveToJobsPlanCreate>>, LocationsJobsPlanMoveToJobsPlanCreateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  locationsJobsPlanMoveToJobsPlanCreate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsJobsPlanMoveToJobsPlanCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsJobsPlanMoveToJobsPlanCreate>>>
    export type LocationsJobsPlanMoveToJobsPlanCreateMutationBody = JobsPlanPromoteRequest
    export type LocationsJobsPlanMoveToJobsPlanCreateMutationError = CustomValidationError | void
    export type LocationsJobsPlanMoveToJobsPlanCreateMutationVariables = {locationId: number;data: JobsPlanPromoteRequest}

    export const useLocationsJobsPlanMoveToJobsPlanCreate = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanMoveToJobsPlanCreate>>, TError,LocationsJobsPlanMoveToJobsPlanCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsJobsPlanMoveToJobsPlanCreate>>,
        TError,
        LocationsJobsPlanMoveToJobsPlanCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsJobsPlanMoveToJobsPlanCreateMutationOptions(options), queryClient);
    }
    export const getLocationsJobsPlanMoveToPayPerHireCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-plan/move-to-pay-per-hire/`
}

/**
 * Staff only: end any open Jobs plan now, with no refund, and keep the location on pay per hire.
 */
export const locationsJobsPlanMoveToPayPerHireCreate = async (locationId: number,
    jobsPlanSwitchRequest: JobsPlanSwitchRequest, options?: Parameters<typeof customFetch>[1]): Promise<JobsSubscriptionStatus> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobsSubscriptionStatus>(getLocationsJobsPlanMoveToPayPerHireCreateUrl(locationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobsPlanSwitchRequest)
  }
);}





export const getLocationsJobsPlanMoveToPayPerHireCreateMutationKey = () => ['locationsJobsPlanMoveToPayPerHireCreate'] as const;

export const getLocationsJobsPlanMoveToPayPerHireCreateMutationOptions = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanMoveToPayPerHireCreate>>, TError,LocationsJobsPlanMoveToPayPerHireCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanMoveToPayPerHireCreate>>, TError,LocationsJobsPlanMoveToPayPerHireCreateMutationVariables, TContext> => {

const mutationKey = getLocationsJobsPlanMoveToPayPerHireCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsJobsPlanMoveToPayPerHireCreate>>, LocationsJobsPlanMoveToPayPerHireCreateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  locationsJobsPlanMoveToPayPerHireCreate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsJobsPlanMoveToPayPerHireCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsJobsPlanMoveToPayPerHireCreate>>>
    export type LocationsJobsPlanMoveToPayPerHireCreateMutationBody = JobsPlanSwitchRequest
    export type LocationsJobsPlanMoveToPayPerHireCreateMutationError = CustomValidationError | void
    export type LocationsJobsPlanMoveToPayPerHireCreateMutationVariables = {locationId: number;data: JobsPlanSwitchRequest}

    export const useLocationsJobsPlanMoveToPayPerHireCreate = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanMoveToPayPerHireCreate>>, TError,LocationsJobsPlanMoveToPayPerHireCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsJobsPlanMoveToPayPerHireCreate>>,
        TError,
        LocationsJobsPlanMoveToPayPerHireCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsJobsPlanMoveToPayPerHireCreateMutationOptions(options), queryClient);
    }
    export const getLocationsJobsPlanSwitchCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-plan/switch/`
}

/**
 * A location admin moves a pay-per-hire location onto the Jobs plan, always by starting the free trial or, when
 * the trial was used, by resubscribing. Repeating a switch that took effect returns the current status.
 */
export const locationsJobsPlanSwitchCreate = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<JobsSubscriptionStatus> => {

  return customFetch<JobsSubscriptionStatus>(getLocationsJobsPlanSwitchCreateUrl(locationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLocationsJobsPlanSwitchCreateMutationKey = () => ['locationsJobsPlanSwitchCreate'] as const;

export const getLocationsJobsPlanSwitchCreateMutationOptions = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanSwitchCreate>>, TError,LocationsJobsPlanSwitchCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanSwitchCreate>>, TError,LocationsJobsPlanSwitchCreateMutationVariables, TContext> => {

const mutationKey = getLocationsJobsPlanSwitchCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsJobsPlanSwitchCreate>>, LocationsJobsPlanSwitchCreateMutationVariables> = (props) => {
          const {locationId} = props ?? {};

          return  locationsJobsPlanSwitchCreate(locationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsJobsPlanSwitchCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsJobsPlanSwitchCreate>>>

    export type LocationsJobsPlanSwitchCreateMutationError = CustomValidationError | void
    export type LocationsJobsPlanSwitchCreateMutationVariables = {locationId: number}

    export const useLocationsJobsPlanSwitchCreate = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsPlanSwitchCreate>>, TError,LocationsJobsPlanSwitchCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsJobsPlanSwitchCreate>>,
        TError,
        LocationsJobsPlanSwitchCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsJobsPlanSwitchCreateMutationOptions(options), queryClient);
    }
    export const getLocationsJobsPlanSwitchPreviewRetrieveUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-plan/switch-preview/`
}

/**
 * Staff only: what moving the location to pay per hire or to the Jobs plan would do.
 */
export const locationsJobsPlanSwitchPreviewRetrieve = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<JobsPlanSwitchPreview> => {

  return customFetch<JobsPlanSwitchPreview>(getLocationsJobsPlanSwitchPreviewRetrieveUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsJobsPlanSwitchPreviewRetrieveQueryKey = (locationId: number,) => {
    return [
    `/api/locations/${locationId}/jobs-plan/switch-preview/`
    ] as const;
    }


export const getLocationsJobsPlanSwitchPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError = void>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsJobsPlanSwitchPreviewRetrieveQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>> = ({ signal }) => locationsJobsPlanSwitchPreviewRetrieve(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsJobsPlanSwitchPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>>
export type LocationsJobsPlanSwitchPreviewRetrieveQueryError = void


export function useLocationsJobsPlanSwitchPreviewRetrieve<TData = Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError = void>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsJobsPlanSwitchPreviewRetrieve<TData = Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsJobsPlanSwitchPreviewRetrieve<TData = Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsJobsPlanSwitchPreviewRetrieve<TData = Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsPlanSwitchPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsJobsPlanSwitchPreviewRetrieveQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsJobsSubscriptionCancelCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-subscription/cancel/`
}

/**
 * One Jobs plan action for the location in the URL. Repeating an action that already took effect returns the
 * current status instead of an error.
 */
export const locationsJobsSubscriptionCancelCreate = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<JobsSubscriptionStatus> => {

  return customFetch<JobsSubscriptionStatus>(getLocationsJobsSubscriptionCancelCreateUrl(locationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLocationsJobsSubscriptionCancelCreateMutationKey = () => ['locationsJobsSubscriptionCancelCreate'] as const;

export const getLocationsJobsSubscriptionCancelCreateMutationOptions = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelCreate>>, TError,LocationsJobsSubscriptionCancelCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelCreate>>, TError,LocationsJobsSubscriptionCancelCreateMutationVariables, TContext> => {

const mutationKey = getLocationsJobsSubscriptionCancelCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelCreate>>, LocationsJobsSubscriptionCancelCreateMutationVariables> = (props) => {
          const {locationId} = props ?? {};

          return  locationsJobsSubscriptionCancelCreate(locationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsJobsSubscriptionCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelCreate>>>

    export type LocationsJobsSubscriptionCancelCreateMutationError = CustomValidationError | void
    export type LocationsJobsSubscriptionCancelCreateMutationVariables = {locationId: number}

    export const useLocationsJobsSubscriptionCancelCreate = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelCreate>>, TError,LocationsJobsSubscriptionCancelCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsJobsSubscriptionCancelCreate>>,
        TError,
        LocationsJobsSubscriptionCancelCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsJobsSubscriptionCancelCreateMutationOptions(options), queryClient);
    }
    export const getLocationsJobsSubscriptionCancelSummaryRetrieveUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-subscription/cancel-summary/`
}

/**
 * Counts for the cancel dialog: what closes when the lapse ends, and what goes ahead regardless.
 */
export const locationsJobsSubscriptionCancelSummaryRetrieve = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<JobsCancelSummary> => {

  return customFetch<JobsCancelSummary>(getLocationsJobsSubscriptionCancelSummaryRetrieveUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsJobsSubscriptionCancelSummaryRetrieveQueryKey = (locationId: number,) => {
    return [
    `/api/locations/${locationId}/jobs-subscription/cancel-summary/`
    ] as const;
    }


export const getLocationsJobsSubscriptionCancelSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError = void>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsJobsSubscriptionCancelSummaryRetrieveQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>> = ({ signal }) => locationsJobsSubscriptionCancelSummaryRetrieve(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsJobsSubscriptionCancelSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>>
export type LocationsJobsSubscriptionCancelSummaryRetrieveQueryError = void


export function useLocationsJobsSubscriptionCancelSummaryRetrieve<TData = Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError = void>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsJobsSubscriptionCancelSummaryRetrieve<TData = Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsJobsSubscriptionCancelSummaryRetrieve<TData = Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsJobsSubscriptionCancelSummaryRetrieve<TData = Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionCancelSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsJobsSubscriptionCancelSummaryRetrieveQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsJobsSubscriptionChargesListUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-subscription/charges/`
}

/**
 * The location's recent Jobs plan charges, newest first, for the Settings card.
 */
export const locationsJobsSubscriptionChargesList = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<JobsSubscriptionCharge[]> => {

  return customFetch<JobsSubscriptionCharge[]>(getLocationsJobsSubscriptionChargesListUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsJobsSubscriptionChargesListQueryKey = (locationId: number,) => {
    return [
    `/api/locations/${locationId}/jobs-subscription/charges/`
    ] as const;
    }


export const getLocationsJobsSubscriptionChargesListQueryOptions = <TData = Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError = void>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsJobsSubscriptionChargesListQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>> = ({ signal }) => locationsJobsSubscriptionChargesList(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsJobsSubscriptionChargesListQueryResult = NonNullable<Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>>
export type LocationsJobsSubscriptionChargesListQueryError = void


export function useLocationsJobsSubscriptionChargesList<TData = Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError = void>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>,
          TError,
          Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsJobsSubscriptionChargesList<TData = Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>,
          TError,
          Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsJobsSubscriptionChargesList<TData = Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsJobsSubscriptionChargesList<TData = Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionChargesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsJobsSubscriptionChargesListQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsJobsSubscriptionResubscribeCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-subscription/resubscribe/`
}

/**
 * One Jobs plan action for the location in the URL. Repeating an action that already took effect returns the
 * current status instead of an error.
 */
export const locationsJobsSubscriptionResubscribeCreate = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<JobsSubscriptionStatus> => {

  return customFetch<JobsSubscriptionStatus>(getLocationsJobsSubscriptionResubscribeCreateUrl(locationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLocationsJobsSubscriptionResubscribeCreateMutationKey = () => ['locationsJobsSubscriptionResubscribeCreate'] as const;

export const getLocationsJobsSubscriptionResubscribeCreateMutationOptions = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionResubscribeCreate>>, TError,LocationsJobsSubscriptionResubscribeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionResubscribeCreate>>, TError,LocationsJobsSubscriptionResubscribeCreateMutationVariables, TContext> => {

const mutationKey = getLocationsJobsSubscriptionResubscribeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsJobsSubscriptionResubscribeCreate>>, LocationsJobsSubscriptionResubscribeCreateMutationVariables> = (props) => {
          const {locationId} = props ?? {};

          return  locationsJobsSubscriptionResubscribeCreate(locationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsJobsSubscriptionResubscribeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsJobsSubscriptionResubscribeCreate>>>

    export type LocationsJobsSubscriptionResubscribeCreateMutationError = CustomValidationError | void
    export type LocationsJobsSubscriptionResubscribeCreateMutationVariables = {locationId: number}

    export const useLocationsJobsSubscriptionResubscribeCreate = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionResubscribeCreate>>, TError,LocationsJobsSubscriptionResubscribeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsJobsSubscriptionResubscribeCreate>>,
        TError,
        LocationsJobsSubscriptionResubscribeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsJobsSubscriptionResubscribeCreateMutationOptions(options), queryClient);
    }
    export const getLocationsJobsSubscriptionTrialCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-subscription/trial/`
}

/**
 * One Jobs plan action for the location in the URL. Repeating an action that already took effect returns the
 * current status instead of an error.
 */
export const locationsJobsSubscriptionTrialCreate = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<JobsSubscriptionStatus> => {

  return customFetch<JobsSubscriptionStatus>(getLocationsJobsSubscriptionTrialCreateUrl(locationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLocationsJobsSubscriptionTrialCreateMutationKey = () => ['locationsJobsSubscriptionTrialCreate'] as const;

export const getLocationsJobsSubscriptionTrialCreateMutationOptions = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionTrialCreate>>, TError,LocationsJobsSubscriptionTrialCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionTrialCreate>>, TError,LocationsJobsSubscriptionTrialCreateMutationVariables, TContext> => {

const mutationKey = getLocationsJobsSubscriptionTrialCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsJobsSubscriptionTrialCreate>>, LocationsJobsSubscriptionTrialCreateMutationVariables> = (props) => {
          const {locationId} = props ?? {};

          return  locationsJobsSubscriptionTrialCreate(locationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsJobsSubscriptionTrialCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsJobsSubscriptionTrialCreate>>>

    export type LocationsJobsSubscriptionTrialCreateMutationError = CustomValidationError | void
    export type LocationsJobsSubscriptionTrialCreateMutationVariables = {locationId: number}

    export const useLocationsJobsSubscriptionTrialCreate = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionTrialCreate>>, TError,LocationsJobsSubscriptionTrialCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsJobsSubscriptionTrialCreate>>,
        TError,
        LocationsJobsSubscriptionTrialCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsJobsSubscriptionTrialCreateMutationOptions(options), queryClient);
    }
    export const getLocationsJobsSubscriptionUndoCancelCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/jobs-subscription/undo-cancel/`
}

/**
 * One Jobs plan action for the location in the URL. Repeating an action that already took effect returns the
 * current status instead of an error.
 */
export const locationsJobsSubscriptionUndoCancelCreate = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<JobsSubscriptionStatus> => {

  return customFetch<JobsSubscriptionStatus>(getLocationsJobsSubscriptionUndoCancelCreateUrl(locationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLocationsJobsSubscriptionUndoCancelCreateMutationKey = () => ['locationsJobsSubscriptionUndoCancelCreate'] as const;

export const getLocationsJobsSubscriptionUndoCancelCreateMutationOptions = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionUndoCancelCreate>>, TError,LocationsJobsSubscriptionUndoCancelCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionUndoCancelCreate>>, TError,LocationsJobsSubscriptionUndoCancelCreateMutationVariables, TContext> => {

const mutationKey = getLocationsJobsSubscriptionUndoCancelCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsJobsSubscriptionUndoCancelCreate>>, LocationsJobsSubscriptionUndoCancelCreateMutationVariables> = (props) => {
          const {locationId} = props ?? {};

          return  locationsJobsSubscriptionUndoCancelCreate(locationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsJobsSubscriptionUndoCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsJobsSubscriptionUndoCancelCreate>>>

    export type LocationsJobsSubscriptionUndoCancelCreateMutationError = CustomValidationError | void
    export type LocationsJobsSubscriptionUndoCancelCreateMutationVariables = {locationId: number}

    export const useLocationsJobsSubscriptionUndoCancelCreate = <TError = CustomValidationError | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsJobsSubscriptionUndoCancelCreate>>, TError,LocationsJobsSubscriptionUndoCancelCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsJobsSubscriptionUndoCancelCreate>>,
        TError,
        LocationsJobsSubscriptionUndoCancelCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsJobsSubscriptionUndoCancelCreateMutationOptions(options), queryClient);
    }
    export const getLocationsReviewsListUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/reviews/`
}

/**
 * Reviews left by pros about a location after completing gigs there.
 *
 * Managers can view reviews for their locations; pros can submit reviews.
 */
export const locationsReviewsList = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<LocationReview[]> => {

  return customFetch<LocationReview[]>(getLocationsReviewsListUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsReviewsListQueryKey = (locationId: number,) => {
    return [
    `/api/locations/${locationId}/reviews/`
    ] as const;
    }


export const getLocationsReviewsListQueryOptions = <TData = Awaited<ReturnType<typeof locationsReviewsList>>, TError = void>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsReviewsListQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsReviewsList>>> = ({ signal }) => locationsReviewsList(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsReviewsListQueryResult = NonNullable<Awaited<ReturnType<typeof locationsReviewsList>>>
export type LocationsReviewsListQueryError = void


export function useLocationsReviewsList<TData = Awaited<ReturnType<typeof locationsReviewsList>>, TError = void>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsReviewsList>>,
          TError,
          Awaited<ReturnType<typeof locationsReviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsReviewsList<TData = Awaited<ReturnType<typeof locationsReviewsList>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsReviewsList>>,
          TError,
          Awaited<ReturnType<typeof locationsReviewsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsReviewsList<TData = Awaited<ReturnType<typeof locationsReviewsList>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsReviewsList<TData = Awaited<ReturnType<typeof locationsReviewsList>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsReviewsListQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsReviewsCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/reviews/`
}

/**
 * Reviews left by pros about a location after completing gigs there.
 *
 * Managers can view reviews for their locations; pros can submit reviews.
 */
export const locationsReviewsCreate = async (locationId: number,
    locationReviewRequest: LocationReviewRequest, options?: Parameters<typeof customFetch>[1]): Promise<LocationReview> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<LocationReview>(getLocationsReviewsCreateUrl(locationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(locationReviewRequest)
  }
);}





export const getLocationsReviewsCreateMutationKey = () => ['locationsReviewsCreate'] as const;

export const getLocationsReviewsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsReviewsCreate>>, TError,LocationsReviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsReviewsCreate>>, TError,LocationsReviewsCreateMutationVariables, TContext> => {

const mutationKey = getLocationsReviewsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsReviewsCreate>>, LocationsReviewsCreateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  locationsReviewsCreate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsReviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsReviewsCreate>>>
    export type LocationsReviewsCreateMutationBody = LocationReviewRequest
    export type LocationsReviewsCreateMutationError = void
    export type LocationsReviewsCreateMutationVariables = {locationId: number;data: LocationReviewRequest}

    export const useLocationsReviewsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsReviewsCreate>>, TError,LocationsReviewsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsReviewsCreate>>,
        TError,
        LocationsReviewsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsReviewsCreateMutationOptions(options), queryClient);
    }
    export const getLocationsReviewsRetrieveUrl = (locationId: number,
    id: string,) => {




  return `/api/locations/${locationId}/reviews/${id}/`
}

/**
 * Reviews left by pros about a location after completing gigs there.
 *
 * Managers can view reviews for their locations; pros can submit reviews.
 */
export const locationsReviewsRetrieve = async (locationId: number,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<LocationReview> => {

  return customFetch<LocationReview>(getLocationsReviewsRetrieveUrl(locationId,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsReviewsRetrieveQueryKey = (locationId: number,
    id: string,) => {
    return [
    `/api/locations/${locationId}/reviews/${id}/`
    ] as const;
    }


export const getLocationsReviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError = void>(locationId: number,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsReviewsRetrieveQueryKey(locationId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsReviewsRetrieve>>> = ({ signal }) => locationsReviewsRetrieve(locationId,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsReviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsReviewsRetrieve>>>
export type LocationsReviewsRetrieveQueryError = void


export function useLocationsReviewsRetrieve<TData = Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError = void>(
 locationId: number,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsReviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsReviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsReviewsRetrieve<TData = Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError = void>(
 locationId: number,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsReviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsReviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsReviewsRetrieve<TData = Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError = void>(
 locationId: number,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsReviewsRetrieve<TData = Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError = void>(
 locationId: number,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsReviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsReviewsRetrieveQueryOptions(locationId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsRetrieveUrl = (id: number,) => {




  return `/api/locations/${id}/`
}

/**
 * A Location represents a business at a physical address.
 *
 * All gigs must be assigned to one Location. There is currently no association between locations.
 * For example, if a business owns multiple locations each location is still treated independently.
 */
export const locationsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ForManagerLocationDetail> => {

  return customFetch<ForManagerLocationDetail>(getLocationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/locations/${id}/`
    ] as const;
    }


export const getLocationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsRetrieve>>> = ({ signal }) => locationsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsRetrieve>>>
export type LocationsRetrieveQueryError = void


export function useLocationsRetrieve<TData = Awaited<ReturnType<typeof locationsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsRetrieve<TData = Awaited<ReturnType<typeof locationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsRetrieve<TData = Awaited<ReturnType<typeof locationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsRetrieve<TData = Awaited<ReturnType<typeof locationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsUpdateUrl = (id: number,) => {




  return `/api/locations/${id}/`
}

/**
 * A Location represents a business at a physical address.
 *
 * All gigs must be assigned to one Location. There is currently no association between locations.
 * For example, if a business owns multiple locations each location is still treated independently.
 */
export const locationsUpdate = async (id: number,
    platformAdminLocationRequest: PlatformAdminLocationRequest, options?: Parameters<typeof customFetch>[1]): Promise<PlatformAdminLocationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<PlatformAdminLocationResponse>(getLocationsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(platformAdminLocationRequest)
  }
);}





export const getLocationsUpdateMutationKey = () => ['locationsUpdate'] as const;

export const getLocationsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsUpdate>>, TError,LocationsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsUpdate>>, TError,LocationsUpdateMutationVariables, TContext> => {

const mutationKey = getLocationsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsUpdate>>, LocationsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  locationsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsUpdate>>>
    export type LocationsUpdateMutationBody = PlatformAdminLocationRequest
    export type LocationsUpdateMutationError = void
    export type LocationsUpdateMutationVariables = {id: number;data: PlatformAdminLocationRequest}

    export const useLocationsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsUpdate>>, TError,LocationsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsUpdate>>,
        TError,
        LocationsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsUpdateMutationOptions(options), queryClient);
    }
    export const getLocationsPartialUpdateUrl = (id: number,) => {




  return `/api/locations/${id}/`
}

/**
 * A Location represents a business at a physical address.
 *
 * All gigs must be assigned to one Location. There is currently no association between locations.
 * For example, if a business owns multiple locations each location is still treated independently.
 */
export const locationsPartialUpdate = async (id: number,
    patchedPlatformAdminLocationRequest?: PatchedPlatformAdminLocationRequest, options?: Parameters<typeof customFetch>[1]): Promise<PlatformAdminLocationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<PlatformAdminLocationResponse>(getLocationsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedPlatformAdminLocationRequest)
  }
);}





export const getLocationsPartialUpdateMutationKey = () => ['locationsPartialUpdate'] as const;

export const getLocationsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsPartialUpdate>>, TError,LocationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsPartialUpdate>>, TError,LocationsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getLocationsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsPartialUpdate>>, LocationsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  locationsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsPartialUpdate>>>
    export type LocationsPartialUpdateMutationBody = PatchedPlatformAdminLocationRequest | undefined
    export type LocationsPartialUpdateMutationError = void
    export type LocationsPartialUpdateMutationVariables = {id: number;data?: PatchedPlatformAdminLocationRequest}

    export const useLocationsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsPartialUpdate>>, TError,LocationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsPartialUpdate>>,
        TError,
        LocationsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getLocationsDestroyUrl = (id: number,) => {




  return `/api/locations/${id}/`
}

/**
 * A Location represents a business at a physical address.
 *
 * All gigs must be assigned to one Location. There is currently no association between locations.
 * For example, if a business owns multiple locations each location is still treated independently.
 */
export const locationsDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getLocationsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLocationsDestroyMutationKey = () => ['locationsDestroy'] as const;

export const getLocationsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsDestroy>>, TError,LocationsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsDestroy>>, TError,LocationsDestroyMutationVariables, TContext> => {

const mutationKey = getLocationsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsDestroy>>, LocationsDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  locationsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof locationsDestroy>>>

    export type LocationsDestroyMutationError = void
    export type LocationsDestroyMutationVariables = {id: number}

    export const useLocationsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsDestroy>>, TError,LocationsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsDestroy>>,
        TError,
        LocationsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsDestroyMutationOptions(options), queryClient);
    }
    export const getLocationsExpressMatchingConfigRetrieveUrl = (id: number,) => {




  return `/api/locations/${id}/express-matching-config/`
}

/**
 * The Express Matching Fee a new shift at this location would carry; nulls when the fee is off.
 */
export const locationsExpressMatchingConfigRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ExpressMatchingConfigResponse> => {

  return customFetch<ExpressMatchingConfigResponse>(getLocationsExpressMatchingConfigRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsExpressMatchingConfigRetrieveQueryKey = (id: number,) => {
    return [
    `/api/locations/${id}/express-matching-config/`
    ] as const;
    }


export const getLocationsExpressMatchingConfigRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsExpressMatchingConfigRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>> = ({ signal }) => locationsExpressMatchingConfigRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsExpressMatchingConfigRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>>
export type LocationsExpressMatchingConfigRetrieveQueryError = void


export function useLocationsExpressMatchingConfigRetrieve<TData = Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsExpressMatchingConfigRetrieve<TData = Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsExpressMatchingConfigRetrieve<TData = Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsExpressMatchingConfigRetrieve<TData = Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsExpressMatchingConfigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsExpressMatchingConfigRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsInvoicingLinkRetrieveUrl = (id: number,) => {




  return `/api/locations/${id}/invoicing-link/`
}

/**
 * A Location represents a business at a physical address.
 *
 * All gigs must be assigned to one Location. There is currently no association between locations.
 * For example, if a business owns multiple locations each location is still treated independently.
 */
export const locationsInvoicingLinkRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getLocationsInvoicingLinkRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsInvoicingLinkRetrieveQueryKey = (id: number,) => {
    return [
    `/api/locations/${id}/invoicing-link/`
    ] as const;
    }


export const getLocationsInvoicingLinkRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError = void | LocationsInvoicingLinkRetrieve404>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsInvoicingLinkRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>> = ({ signal }) => locationsInvoicingLinkRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsInvoicingLinkRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>>
export type LocationsInvoicingLinkRetrieveQueryError = void | LocationsInvoicingLinkRetrieve404


export function useLocationsInvoicingLinkRetrieve<TData = Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError = void | LocationsInvoicingLinkRetrieve404>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsInvoicingLinkRetrieve<TData = Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError = void | LocationsInvoicingLinkRetrieve404>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsInvoicingLinkRetrieve<TData = Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError = void | LocationsInvoicingLinkRetrieve404>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsInvoicingLinkRetrieve<TData = Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError = void | LocationsInvoicingLinkRetrieve404>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsInvoicingLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsInvoicingLinkRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsPaymentMethodRetrieveUrl = (id: number,
    params?: LocationsPaymentMethodRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/locations/${id}/payment-method/?${stringifiedParams}` : `/api/locations/${id}/payment-method/`
}

/**
 * A Location represents a business at a physical address.
 *
 * All gigs must be assigned to one Location. There is currently no association between locations.
 * For example, if a business owns multiple locations each location is still treated independently.
 */
export const locationsPaymentMethodRetrieve = async (id: number,
    params?: LocationsPaymentMethodRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<LocationBillingInfo> => {

  return customFetch<LocationBillingInfo>(getLocationsPaymentMethodRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsPaymentMethodRetrieveQueryKey = (id: number,
    params?: LocationsPaymentMethodRetrieveParams,) => {
    return [
    `/api/locations/${id}/payment-method/`, ...(params ? [params] : [])
    ] as const;
    }


export const getLocationsPaymentMethodRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError = void>(id: number,
    params?: LocationsPaymentMethodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsPaymentMethodRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>> = ({ signal }) => locationsPaymentMethodRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsPaymentMethodRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>>
export type LocationsPaymentMethodRetrieveQueryError = void


export function useLocationsPaymentMethodRetrieve<TData = Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError = void>(
 id: number,
    params: undefined |  LocationsPaymentMethodRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsPaymentMethodRetrieve<TData = Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError = void>(
 id: number,
    params?: LocationsPaymentMethodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsPaymentMethodRetrieve<TData = Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError = void>(
 id: number,
    params?: LocationsPaymentMethodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsPaymentMethodRetrieve<TData = Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError = void>(
 id: number,
    params?: LocationsPaymentMethodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsPaymentMethodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsPaymentMethodRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsSetupIntentRetrieveUrl = (id: number,) => {




  return `/api/locations/${id}/setup-intent/`
}

/**
 * Returns a Stripe SetupIntent id for the purpose of adding a payment method.
 */
export const locationsSetupIntentRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<LocationSetupIntentResponse> => {

  return customFetch<LocationSetupIntentResponse>(getLocationsSetupIntentRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsSetupIntentRetrieveQueryKey = (id: number,) => {
    return [
    `/api/locations/${id}/setup-intent/`
    ] as const;
    }


export const getLocationsSetupIntentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsSetupIntentRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>> = ({ signal }) => locationsSetupIntentRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsSetupIntentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>>
export type LocationsSetupIntentRetrieveQueryError = void


export function useLocationsSetupIntentRetrieve<TData = Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsSetupIntentRetrieve<TData = Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsSetupIntentRetrieve<TData = Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsSetupIntentRetrieve<TData = Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsSetupIntentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsSetupIntentRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsStatsRetrieveUrl = (id: number,) => {




  return `/api/locations/${id}/stats/`
}

/**
 * A Location represents a business at a physical address.
 *
 * All gigs must be assigned to one Location. There is currently no association between locations.
 * For example, if a business owns multiple locations each location is still treated independently.
 */
export const locationsStatsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<LocationStatsOld> => {

  return customFetch<LocationStatsOld>(getLocationsStatsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsStatsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/locations/${id}/stats/`
    ] as const;
    }


export const getLocationsStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsStatsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsStatsRetrieve>>> = ({ signal }) => locationsStatsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsStatsRetrieve>>>
export type LocationsStatsRetrieveQueryError = void


export function useLocationsStatsRetrieve<TData = Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsStatsRetrieve<TData = Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsStatsRetrieve<TData = Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsStatsRetrieve<TData = Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsStatsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsStipeCustomerPortalSessionCreateUrl = (id: number,) => {




  return `/api/locations/${id}/stipe-customer-portal-session/`
}

/**
 * Returns Stripe customer portal url.
 */
export const locationsStipeCustomerPortalSessionCreate = async (id: number,
    platformAdminLocationResponseRequest: PlatformAdminLocationResponseRequest, options?: Parameters<typeof customFetch>[1]): Promise<string> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<string>(getLocationsStipeCustomerPortalSessionCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(platformAdminLocationResponseRequest)
  }
);}





export const getLocationsStipeCustomerPortalSessionCreateMutationKey = () => ['locationsStipeCustomerPortalSessionCreate'] as const;

export const getLocationsStipeCustomerPortalSessionCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsStipeCustomerPortalSessionCreate>>, TError,LocationsStipeCustomerPortalSessionCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsStipeCustomerPortalSessionCreate>>, TError,LocationsStipeCustomerPortalSessionCreateMutationVariables, TContext> => {

const mutationKey = getLocationsStipeCustomerPortalSessionCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsStipeCustomerPortalSessionCreate>>, LocationsStipeCustomerPortalSessionCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  locationsStipeCustomerPortalSessionCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsStipeCustomerPortalSessionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsStipeCustomerPortalSessionCreate>>>
    export type LocationsStipeCustomerPortalSessionCreateMutationBody = PlatformAdminLocationResponseRequest
    export type LocationsStipeCustomerPortalSessionCreateMutationError = void
    export type LocationsStipeCustomerPortalSessionCreateMutationVariables = {id: number;data: PlatformAdminLocationResponseRequest}

    export const useLocationsStipeCustomerPortalSessionCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsStipeCustomerPortalSessionCreate>>, TError,LocationsStipeCustomerPortalSessionCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsStipeCustomerPortalSessionCreate>>,
        TError,
        LocationsStipeCustomerPortalSessionCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsStipeCustomerPortalSessionCreateMutationOptions(options), queryClient);
    }
    export const getLocationsBusinessSignupRequestCreateUrl = () => {




  return `/api/locations/business-signup-request/`
}

/**
 * Queue a Slack notification to #gp-business-signups with manager contact details.
 */
export const locationsBusinessSignupRequestCreate = async (businessSignupRequestRequest: BusinessSignupRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getLocationsBusinessSignupRequestCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(businessSignupRequestRequest)
  }
);}





export const getLocationsBusinessSignupRequestCreateMutationKey = () => ['locationsBusinessSignupRequestCreate'] as const;

export const getLocationsBusinessSignupRequestCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsBusinessSignupRequestCreate>>, TError,LocationsBusinessSignupRequestCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsBusinessSignupRequestCreate>>, TError,LocationsBusinessSignupRequestCreateMutationVariables, TContext> => {

const mutationKey = getLocationsBusinessSignupRequestCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsBusinessSignupRequestCreate>>, LocationsBusinessSignupRequestCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  locationsBusinessSignupRequestCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsBusinessSignupRequestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsBusinessSignupRequestCreate>>>
    export type LocationsBusinessSignupRequestCreateMutationBody = BusinessSignupRequestRequest
    export type LocationsBusinessSignupRequestCreateMutationError = void
    export type LocationsBusinessSignupRequestCreateMutationVariables = {data: BusinessSignupRequestRequest}

    export const useLocationsBusinessSignupRequestCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsBusinessSignupRequestCreate>>, TError,LocationsBusinessSignupRequestCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsBusinessSignupRequestCreate>>,
        TError,
        LocationsBusinessSignupRequestCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsBusinessSignupRequestCreateMutationOptions(options), queryClient);
    }
    export const getLocationsCheckDuplicateCreateUrl = () => {




  return `/api/locations/check-duplicate/`
}

/**
 * Check whether a Location with the same Google places_id already exists.
 */
export const locationsCheckDuplicateCreate = async (checkDuplicateRequest: CheckDuplicateRequest, options?: Parameters<typeof customFetch>[1]): Promise<CheckDuplicateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CheckDuplicateResponse>(getLocationsCheckDuplicateCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(checkDuplicateRequest)
  }
);}





export const getLocationsCheckDuplicateCreateMutationKey = () => ['locationsCheckDuplicateCreate'] as const;

export const getLocationsCheckDuplicateCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsCheckDuplicateCreate>>, TError,LocationsCheckDuplicateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsCheckDuplicateCreate>>, TError,LocationsCheckDuplicateCreateMutationVariables, TContext> => {

const mutationKey = getLocationsCheckDuplicateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsCheckDuplicateCreate>>, LocationsCheckDuplicateCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  locationsCheckDuplicateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsCheckDuplicateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsCheckDuplicateCreate>>>
    export type LocationsCheckDuplicateCreateMutationBody = CheckDuplicateRequest
    export type LocationsCheckDuplicateCreateMutationError = void
    export type LocationsCheckDuplicateCreateMutationVariables = {data: CheckDuplicateRequest}

    export const useLocationsCheckDuplicateCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsCheckDuplicateCreate>>, TError,LocationsCheckDuplicateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsCheckDuplicateCreate>>,
        TError,
        LocationsCheckDuplicateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsCheckDuplicateCreateMutationOptions(options), queryClient);
    }
    export const getLocationsMatchCreateUrl = () => {




  return `/api/locations/match/`
}

/**
 * Score whether a scraped job posting belongs at a given Sidegig Location.
 *
 * Gated to the `job_crawler` service group — the job-crawler service uses
 * this per scraped serp result to filter out near-misses that the search
 * engine returned by proximity but aren't actually jobs at the location.
 * Not exposed to end users.
 *
 * Returns `{location_id, location_name, confidence}` on a hit. Returns 404
 * when `location_id` does not exist. The view applies no confidence
 * threshold — callers decide what counts as a good enough match.
 */
export const locationsMatchCreate = async (locationMatchRequestRequest: LocationMatchRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<LocationMatchResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<LocationMatchResponse>(getLocationsMatchCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(locationMatchRequestRequest)
  }
);}





export const getLocationsMatchCreateMutationKey = () => ['locationsMatchCreate'] as const;

export const getLocationsMatchCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsMatchCreate>>, TError,LocationsMatchCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsMatchCreate>>, TError,LocationsMatchCreateMutationVariables, TContext> => {

const mutationKey = getLocationsMatchCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsMatchCreate>>, LocationsMatchCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  locationsMatchCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsMatchCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsMatchCreate>>>
    export type LocationsMatchCreateMutationBody = LocationMatchRequestRequest
    export type LocationsMatchCreateMutationError = void
    export type LocationsMatchCreateMutationVariables = {data: LocationMatchRequestRequest}

    export const useLocationsMatchCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsMatchCreate>>, TError,LocationsMatchCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsMatchCreate>>,
        TError,
        LocationsMatchCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsMatchCreateMutationOptions(options), queryClient);
    }
    export const getLocationsTopByPostingsListUrl = (params: LocationsTopByPostingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/locations/top-by-postings/?${stringifiedParams}` : `/api/locations/top-by-postings/`
}

/**
 * Top N locations in a market by total postings (gigs + job postings) since a date.
 *
 * Accessible to admins and job_crawler service accounts.
 */
export const locationsTopByPostingsList = async (params: LocationsTopByPostingsListParams, options?: Parameters<typeof customFetch>[1]): Promise<TopLocationsAdmin[]> => {

  return customFetch<TopLocationsAdmin[]>(getLocationsTopByPostingsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsTopByPostingsListQueryKey = (params?: LocationsTopByPostingsListParams,) => {
    return [
    `/api/locations/top-by-postings/`, ...(params ? [params] : [])
    ] as const;
    }


export const getLocationsTopByPostingsListQueryOptions = <TData = Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError = void>(params: LocationsTopByPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsTopByPostingsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsTopByPostingsList>>> = ({ signal }) => locationsTopByPostingsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsTopByPostingsListQueryResult = NonNullable<Awaited<ReturnType<typeof locationsTopByPostingsList>>>
export type LocationsTopByPostingsListQueryError = void


export function useLocationsTopByPostingsList<TData = Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError = void>(
 params: LocationsTopByPostingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsTopByPostingsList>>,
          TError,
          Awaited<ReturnType<typeof locationsTopByPostingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsTopByPostingsList<TData = Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError = void>(
 params: LocationsTopByPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsTopByPostingsList>>,
          TError,
          Awaited<ReturnType<typeof locationsTopByPostingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsTopByPostingsList<TData = Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError = void>(
 params: LocationsTopByPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsTopByPostingsList<TData = Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError = void>(
 params: LocationsTopByPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsTopByPostingsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsTopByPostingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






